import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import miroSrc from '@common/assets/images/miro.webp';
import zoomSrc from '@common/assets/images/zoom.webp';
import { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';

import LessonsLinkItem from './Item';
import {
	StyledLessonLinkItemTitleImage,
	StyledLessonLinkItemTitleWrap,
	StyledLessonLinkList,
} from './styled';

interface PropsType {
	lessonModel: IStudentLessonModel;
}

function LinkSectionHelpfulLinks({ lessonModel }: PropsType) {
	const { t } = useTranslation();

	if (
		!lessonModel.schedule_program?.zoom_link &&
		!lessonModel.schedule_program?.miro_link &&
		!lessonModel.schedule_program?.discussion_link
	) {
		return null;
	}

	return (
		<>
			<Typography variant="subtitle2">{t('lesson.links')}</Typography>
			<StyledLessonLinkList>
				{!!lessonModel.schedule_program?.zoom_link && (
					<LessonsLinkItem
						title={
							<StyledLessonLinkItemTitleWrap>
								<StyledLessonLinkItemTitleImage src={zoomSrc} alt="zoom" />
								{t('lesson.zoomLink')}
							</StyledLessonLinkItemTitleWrap>
						}
						href={lessonModel.schedule_program?.zoom_link}
					/>
				)}
				{lessonModel.schedule_program?.zoom_id && (
					<Typography>
						{t('lesson.zoomId')}: {lessonModel.schedule_program?.zoom_id}
					</Typography>
				)}
				{lessonModel.schedule_program?.zoom_access_code && (
					<Typography>
						{t('lesson.zoomAccessCode')}: {lessonModel.schedule_program?.zoom_access_code}
					</Typography>
				)}

				{!!lessonModel.schedule_program?.miro_link && (
					<LessonsLinkItem
						title={
							<StyledLessonLinkItemTitleWrap>
								<StyledLessonLinkItemTitleImage src={miroSrc} alt="miro" />
								{t('lesson.miroLink')}
							</StyledLessonLinkItemTitleWrap>
						}
						href={lessonModel.schedule_program?.miro_link}
					/>
				)}

				{!!lessonModel.schedule_program?.miro_link && (
					<LessonsLinkItem
						title={
							<StyledLessonLinkItemTitleWrap>
								<StyledLessonLinkItemTitleImage src={miroSrc} alt="miro" />
								{t('lesson.miroLink')}
							</StyledLessonLinkItemTitleWrap>
						}
						href={lessonModel.schedule_program?.miro_link}
					/>
				)}

				{!!lessonModel.schedule_program?.discussion_link && (
					<LessonsLinkItem
						isCommonLink
						title={
							<StyledLessonLinkItemTitleWrap>
								{t('lesson.discussionBoard')}
							</StyledLessonLinkItemTitleWrap>
						}
						href={lessonModel.schedule_program?.discussion_link}
					/>
				)}
			</StyledLessonLinkList>
		</>
	);
}

export default LinkSectionHelpfulLinks;
